import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiHeart } from "react-icons/fi";
import { Container } from "react-bootstrap";

export default function Footer() {
  return (
    <>
      <div>
        <footer className="gi-footer">
          <div className="gi-footer-main">
            <div>
              <div className="gi-footer-brand">

                <div><small>All Rights Reserved | Powered By Global Inavation</small></div>
              </div>

            </div>

          </div>


        </footer >
      </div >

    </>
  )
};


